const initialState = {
  locale: "en",
  twelveDates: false,
  wideAlarms: false,
  rawAlarms: true,
  ingame: {
    prefix: "!",
    enabled: false,
    keepLeader: false
  },
  discord: {
    channel: {
      clean: false,
      main: false,
      alerts: false,
      events: false,
      commands: false
    }
  },
  events: [
    {
      "key": "heliDowned",
      "ingame": false,
      "discord": false,
      "distance": false
      },
      {
      "key": "cargoLeft",
      "ingame": false,
      "discord": false,
      "distance": false
      },
      {
      "key": "cargoEnter",
      "ingame": false,
      "discord": false,
      "distance": false
      },
      {
      "key": "cargoLastCrate",
      "ingame": false,
      "discord": false,
      "distance": false
      },
  ]
};

export const settings = (state = initialState, action) => {
  switch (action.type) {
    case 'INIT_SET_SETTINGS': {
      return {
        ...action.settings
      };
    }
    case 'SETTINGS_SWITCH_EVENTS' : {
      var tempArray = [...state.events], index = tempArray.findIndex((g) => g.key === action.key);
      if (index === -1) return state;
      tempArray[index][action.room] = action.value;
      return {
        ...state,
        events: [...tempArray]
      }
    }
    case 'SETTINGS_SWITCH_CHANNELS' : {
      var temp = JSON.parse(JSON.stringify(state.discord.channel));
      temp[action.key] = action.value;
      return {
        ...state,
        discord: {
          ...state.discord,
          channel: temp
        }
      }
    }
    case 'SETTINGS_SWITCH' : {
      var res = JSON.parse(JSON.stringify(state));
      const checkObject = action.key.split('.');
      if (checkObject.length > 1) res[checkObject[0]][checkObject[1]] = action.value;
      else res[action.key] = action.value;
      return res;
    }
    case 'SET_LANG': {
      return {
        ...state,
        locale: action.locale
      }
    }
    default:
      return state;
  }
};
